module.exports = __webpack_public_path__ + "img/酒某.e4e02d29.jpg";